import { Link } from 'react-router-dom';
import { strategies } from '@/mocks/strategies';

export default function HomeStrategies() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 text-xs font-semibold px-4 py-2 rounded-full mb-4">
              <i className="ri-flashlight-line"></i>
              Estratégias Comprovadas
            </div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#0d1f3c]">
              Estratégias de Trading de Futuros
            </h2>
            <p className="text-slate-500 mt-3 max-w-xl">
              Análises detalhadas de cada metodologia, com pontos fortes, fracos e compatibilidade com prop firms.
            </p>
          </div>
          <Link
            to="/estrategias"
            className="shrink-0 inline-flex items-center gap-2 border border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white font-semibold px-6 py-3 rounded-full text-sm transition-all cursor-pointer whitespace-nowrap"
          >
            Ver todas
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {strategies.slice(0, 6).map((s) => (
            <Link
              key={s.id}
              to={`/estrategias/${s.id}`}
              className="group relative rounded-2xl overflow-hidden cursor-pointer"
            >
              <div className="aspect-[16/10] w-full">
                <img
                  src={s.image}
                  alt={s.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#0d1f3c] via-[#0d1f3c]/40 to-transparent"></div>
              <div className="absolute inset-0 p-6 flex flex-col justify-end">
                <div className="flex gap-2 mb-3">
                  <span className="bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full">{s.timeframe}</span>
                  <span className="bg-white/20 text-white text-xs font-semibold px-3 py-1 rounded-full">{s.risk}</span>
                </div>
                <h3 className="text-xl font-bold text-white mb-1">{s.name}</h3>
                <p className="text-slate-300 text-sm">{s.tagline}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
